var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _vm._t("default", null, {
        items: _vm.paginationData.data,
        currentPage: _vm.paginationData.current_page,
        perPage: _vm.resultsPerPage,
        reorderOffset: _vm.reorderOffset,
        reorder: _vm.reorder,
        showSlideOver: _vm.showSlideOver,
        reload: _vm.getData,
      }),
      _vm._v(" "),
      _c(
        "nav",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paginationData.last_page !== 1,
              expression: "paginationData.last_page !== 1",
            },
          ],
          staticClass:
            "border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-6",
        },
        [
          _c("div", { staticClass: "w-0 flex-1 flex" }, [
            _c(
              "a",
              {
                staticClass:
                  "-mt-px border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm leading-5 font-medium hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150",
                class: {
                  "text-gray-300": _vm.paginationData.current_page === 1,
                  "text-gray-500": _vm.paginationData.current_page !== 1,
                },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.previousPage.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "mr-3 h-5 w-5",
                    class: {
                      "text-gray-300": _vm.paginationData.current_page === 1,
                      "text-gray-400": _vm.paginationData.current_page !== 1,
                    },
                    attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                        "clip-rule": "evenodd",
                      },
                    }),
                  ]
                ),
                _vm._v("\n                Previous\n            "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hidden md:flex" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "-mt-px border-t-2 pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium focus:outline-none transition ease-in-out duration-150",
                  class: {
                    "border-primary-500 text-primary-600 focus:text-primary-800 focus:border-primary-700":
                      _vm.paginationData.current_page === 1,
                    "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-400":
                      _vm.paginationData.current_page !== 1,
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setPage(1)
                    },
                  },
                },
                [_vm._v("\n                1\n            ")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLeftEllipsis,
                      expression: "showLeftEllipsis",
                    },
                  ],
                  staticClass:
                    "-mt-px border-t-2 border-transparent pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium text-gray-500",
                },
                [_vm._v("\n                ...\n            ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.displayPages, function (page) {
                return _c(
                  "a",
                  {
                    staticClass:
                      "-mt-px border-t-2 pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium focus:outline-none transition ease-in-out duration-150",
                    class: {
                      "border-primary-500 text-primary-600 focus:text-primary-800 focus:border-primary-700":
                        _vm.paginationData.current_page === page,
                      "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-400":
                        _vm.paginationData.current_page !== page,
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.setPage(page)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(page) + "\n            "
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showRightEllipsis,
                      expression: "showRightEllipsis",
                    },
                  ],
                  staticClass:
                    "-mt-px border-t-2 border-transparent pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium text-gray-500",
                },
                [_vm._v("\n                ...\n            ")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "-mt-px border-t-2 pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium focus:outline-none transition ease-in-out duration-150",
                  class: {
                    "border-primary-500 text-primary-600 focus:text-primary-800 focus:border-primary-700":
                      _vm.paginationData.current_page ===
                      _vm.paginationData.last_page,
                    "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-400":
                      _vm.paginationData.current_page !==
                      _vm.paginationData.last_page,
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setPage(_vm.paginationData.last_page)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.paginationData.last_page) +
                      "\n            "
                  ),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-0 flex-1 flex justify-end" }, [
            _c(
              "a",
              {
                staticClass:
                  "-mt-px border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm leading-5 font-medium hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150",
                class: {
                  "text-gray-300":
                    _vm.paginationData.current_page ===
                    _vm.paginationData.last_page,
                  "text-gray-500":
                    _vm.paginationData.current_page !==
                    _vm.paginationData.last_page,
                },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.nextPage.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v("\n                Next\n                "),
                _c(
                  "svg",
                  {
                    staticClass: "ml-3 h-5 w-5",
                    class: {
                      "text-gray-300":
                        _vm.paginationData.current_page ===
                        _vm.paginationData.last_page,
                      "text-gray-400":
                        _vm.paginationData.current_page !==
                        _vm.paginationData.last_page,
                    },
                    attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                        "clip-rule": "evenodd",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center mt-4" }, [
        _c("span", { staticClass: "text-gray-500 text-sm" }, [
          _vm._v("Results per page"),
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.resultsPerPage,
                expression: "resultsPerPage",
              },
            ],
            staticClass: "form-select ml-2",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.resultsPerPage = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "25" } }, [_vm._v("25")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "60" } }, [_vm._v("60")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "75" } }, [_vm._v("75")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "90" } }, [_vm._v("90")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "100" } }, [_vm._v("100")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass:
            "absolute z-10 inset-0 bg-translucent-white-75 flex items-center justify-center",
        },
        [_c("preloader")],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "slideover" } },
        [
          _vm.displaySlideOver
            ? _c(
                "slide-over",
                {
                  ref: "slideOver",
                  attrs: { heading: _vm.slideOverHeading },
                  on: {
                    hide: function ($event) {
                      _vm.displaySlideOver = false
                    },
                  },
                },
                [
                  _vm._t("slideOverBody"),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "footer" },
                    [
                      _vm._t("slideOverFooter", null, {
                        hideSlideOver: _vm.hideSlideOver,
                        getData: _vm.getData,
                      }),
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }